var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1855 2.75305V6.34905C14.1855 6.83605 14.3805 7.30405 14.7255 7.64905C15.0724 7.99442 15.542 8.18824 16.0315 8.18805H20.1565",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.647 7.64703H10.912M7.647 12H16.353M7.647 16.353H16.353M20.25 8.56803V17.136C20.2301 17.6965 20.0996 18.2474 19.8658 18.7571C19.6321 19.2669 19.2997 19.7253 18.888 20.106C18.4759 20.4885 17.9925 20.786 17.4654 20.9817C16.9383 21.1773 16.3778 21.2671 15.816 21.246H8.226C7.66074 21.2719 7.09594 21.1859 6.56398 20.993C6.03201 20.8001 5.54335 20.5041 5.126 20.122C4.71027 19.7403 4.37454 19.2797 4.13833 18.7671C3.90211 18.2545 3.77011 17.7001 3.75 17.136V6.86203C3.76985 6.3016 3.90042 5.75065 4.13418 5.24091C4.36794 4.73118 4.70026 4.27274 5.112 3.89203C5.52408 3.50955 6.00748 3.21201 6.53458 3.01641C7.06169 2.8208 7.62217 2.73096 8.184 2.75203H13.898C14.7703 2.74895 15.6123 3.07169 16.259 3.65703L19.219 6.37903C19.5349 6.65111 19.7899 6.98663 19.9675 7.36378C20.1452 7.74092 20.2414 8.15123 20.25 8.56803Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9070d22983c6ca1fd40c54b69a272f41.svg";
export { ForwardRef as ReactComponent };